
<template>
  <el-form label-width="100px">
    <el-row :gutter="20">
      <el-col :span="5">
        <el-form-item label="店铺别名：">
          <el-select v-model="form.vendorAliasId" filterable clearable placeholder="请选择">
            <el-option v-for="item in vendorList" :key="item.value" :label="item.vendorNameAlias" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="买手店：">
          <el-select v-model="form.vendorId" filterable clearable placeholder="请选择">
            <el-option v-for="item in vendorList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="订单号：">
          <el-input v-model="form.orderLineNum" />
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="发信状态：">
          <el-select v-model="form.status" clearable placeholder="请选择">
            <el-option v-for="item in emailStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="收件地址：">
          <el-input v-model="form.addressTo" />
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="发信方式：">
          <el-select v-model="form.sendMethod" clearable placeholder="请选择">
            <el-option v-for="item in sendMethod" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="10">
        <el-form-item label="推送时间：">
          <el-date-picker v-model="timeRange" type="datetimerange" value-format="timestamp" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="原因查询：">
          <el-input v-model="form.reason" />
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="">
          <el-button type="primary" size="small" @click.stop="submit">查询</el-button>
          <el-button size="small" @click.stop="reset">重置</el-button>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { getVendorsByVendorName } from './api.js'
export default {
  data() {
    return {
      emailStatus: [
        { label: '异常', value: -1 },
        { label: '正常', value: 0 },
        { label: '待发送', value: 1 }
      ],
      sendMethod: [
        { label: 'SMTP', value: 1 },
        { label: '邮件服务', value: 2 }
      ],
      timeRange: [],
      vendorList: [],
      form: {}
    };
  },
  async created() {
    const res = (await getVendorsByVendorName()).data;
    this.vendorList = (res || []).map(item => { return { label: item.vendorName, value: item.vendorId, vendorNameAlias: item.vendorNameAlias } })
  },
  methods: {
    strim(str) {
      return str.replace(/(^\s*)|(\s*$)/g, "");
    },
    setToNull(str) {
      if (typeof this.form[str] === "string") {
        this.form[str] = this.strim(this.form[str]);
        if (!this.form[str]) {
          this.form[str] = null;
        }
      }
    },
    newTheme() { },
    submit() {
      var handleFormData = {};
      Object.keys(this.form).forEach(item => {
        handleFormData[item] = this.form[item]
      });
      handleFormData.startTime = this.timeRange[0];
      handleFormData.endTime = this.timeRange[1];
      if (this.form.vendorAliasId) {
        handleFormData.vendorId = this.form.vendorAliasId;
      }
      this.$emit("query", handleFormData);
    },
    reset() {
      this.form = {};
      this.timeRange = []
      this.$emit("reset");
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-date-editor .el-range-separator {
  width: 7%;
}
.newBtn {
  margin-left: 20px;
  width: 100px;
}
</style>
